import { skillProblem } from "@gigsync/protocol";
import { tradeNamed } from "../interview/lexicon.js";
const SPACES = /\s+/gu;
export function readSkill(text, lang) {
    const trade = tradeNamed(text);
    if (trade)
        return { trade };
    const words = text.trim().replace(SPACES, " ");
    const problem = skillProblem(words);
    return problem ? { problem } : { skill: { text: words, lang } };
}
/** Words around a spoken skill that only say "I am" or "I do" ("I am a tailor", "मैं दर्ज़ी हूँ"), in any of the scripts. */
const FILLER = new Set([
    "i",
    "im",
    "i'm",
    "am",
    "a",
    "an",
    "do",
    "main",
    "hoon",
    "hun",
    "मैं",
    "हूँ",
    "हूं",
    "हूँ।",
    "ನಾನು",
    "ಮಾಡುತ್ತೇನೆ",
]);
/** A skill as the card interview heard it, without the filler words at either end; the rest as said. */
export function spokenSkill(text) {
    const words = text.trim().split(SPACES);
    const filler = (w) => w !== undefined && FILLER.has(w.toLowerCase());
    while (words.length > 1 && filler(words[0]))
        words.shift();
    while (words.length > 1 && filler(words.at(-1)))
        words.pop();
    return words.join(" ");
}
//# sourceMappingURL=read.js.map